import { useBqns } from "common/BqnContext";
import { createSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";

const StyledDiv = styled.div`
  .kpi {
    margin-bottom: 0 !important;
    display: flex;
    justify-content: end;
    align-items: end;
    flex-direction: column;
  }

  .direction {
    display: flex;
    align-items: center;
  }

  .kpi-item {
      display: flex;
      align-items: center;
      justify-content: end;
      width: 160px;
      max-width: 160px;

      .online-icon{
        margin-top: 8px;
      }
    }

  .kpi-group {
    display: flex;
    align-items: center;
    justify-content: end;
    margin-bottom: 0 !important;

    .kpi{
      width: 160px;
      max-width: 160px;
    }
  }

  .db-counters {
    .unit {
      margin-left: 5px;
      margin-bottom: 0px;
    }

    font-family: "IBM Plex Mono", monospace !important;
    font-weight: 500 !important;

    &.speed{
      white-space: nowrap;
    }
  }

  .body {
    padding: 0px 15px 15px 15px;
  }

  .content {
    display: flex;
  }

  .content .body {
    width: 100%;
  }

  .online-status {
    font-family: "AllianceNo2-Bold";
    color: var(--Text-Inverted);
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px;

    &.complete {
      background-color: var(--signal-green);
    }

    &.incomplete {
      background-color: var(--signal-yellow);
    }
  }

  .kpis {
    display: flex;
    align-items: end;
    flex-wrap: wrap;
  }

  @media (min-width: 992px) {
    .col-md-12 {
      width: 100%;
    }

    .col-md-6 {
      width: 50%;
    }

    .col-md-4 {
      width: 33.33333333%;
    }

    .col-md-8 {
      width: 66.66666667%;
    }

    .col-md-10 {
      width: 83.33333333%;
    }

    .col-md-2 {
      width: 16.66666667%;
    }
  }

  @media (min-width: 1400px) {
    .col-lg-4 {
      width: 33.33333333% !important;
    }

    .col-lg-2 {
      width: 16.66666667%;
    }
  }
`;

function displaySpeed(speedMbps) {
  const displayedSpeed = speedMbps > 1000 ? speedMbps / 1000 : speedMbps;
  const unit = speedMbps > 1000 ? "Gbps" : "Mbps";

  return (
    <>
      {noSlashedZero(displayedSpeed.toFixed(3))}
      <label className="unit"> {unit} </label>
    </>
  );
}

function noSlashedZero(value){
  return value.toString().replaceAll('0', 'O')
}

export function ClusterSummary({
  totalDownlink,
  totalUplink,
  totalSubscribers,
  totalFlows,
  optPercentage,
  totalSubscriberGroups,
}) {
  const navigate = useNavigate();
  const bqns = useBqns();
  const clusterComplete =
    bqns.findIndex((bqn) => bqn.function === "offline") === -1;

  return (
    <StyledDiv className="card">
      <div className="content">
        <div
          className={`online-status ${
            clusterComplete ? "complete" : "incomplete"
          }`}
        >
          {clusterComplete ? "Online" : "Incomplete"}
        </div>
        <div className="body">
          <div className="row kpis">
            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 kpi">
              <div className="direction">
                <div className="kpi-item">
                  <div className="online-icon">
                    <i className="material-icons">arrow_downward</i>
                  </div>
                  <div
                    className="h3 font-bold db-counters hyperlink-text-nocolor speed align-right"
                    onClick={() =>
                      navigate({
                        pathname: "/viewCongestionACM",
                        search: createSearchParams({
                          returnView: "viewClusterDashboard",
                        }).toString(),
                      })
                    }
                  >
                    {displaySpeed(totalDownlink)}
                  </div>
                </div>
                <div className="kpi-item">
                  <div className="online-icon">
                    <i className="material-icons">arrow_upward</i>
                  </div>
                  <div
                    className="h3 font-bold db-counters hyperlink-text-nocolor align-right speed"
                    onClick={() =>
                      navigate({
                        pathname: "/viewCongestionACM",
                        search: createSearchParams({
                          returnView: "viewClusterDashboard",
                        }).toString(),
                      })
                    }
                  >
                    {displaySpeed(totalUplink)}
                  </div>
                </div>
              </div>
              <div>Total Throughput</div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 kpi-group">
              <div className="kpi">
                <div
                  className="h3 font-bold db-counters hyperlink-text-nocolor align-right"
                  onClick={() =>
                    navigate({
                      pathname: "/viewStatusSubscribers",
                      search: createSearchParams({
                        returnView: "viewClusterDashboard",
                      }).toString(),
                    })
                  }
                >
                  {noSlashedZero(totalSubscribers)}
                </div>
                <div>Subscribers</div>
              </div>
              <div className="kpi">
                <div
                  onClick={() =>
                    navigate({
                      pathname: "/viewStatusSubscriberGroups",
                      search: createSearchParams({
                        returnView: "viewClusterDashboard",
                      }).toString(),
                    })
                  }
                  className="h3 font-bold db-counters hyperlink-text-nocolor align-right"
                >
                  {noSlashedZero(totalSubscriberGroups)}
                </div>
                <div>Groups</div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 kpi-group">
              <div className="kpi">
                <div
                  onClick={() =>
                    navigate({
                      pathname: "/viewFlowsPerSubs",
                      search: createSearchParams({
                        returnView: "viewClusterDashboard",
                      }).toString(),
                    })
                  }
                  className="h3 font-bold db-counters hyperlink-text-nocolor align-right"
                >
                  {noSlashedZero(totalFlows)}
                </div>
                <div>Flows</div>
              </div>
              <div className="kpi">
                <div
                  onClick={() =>
                    navigate({
                      pathname: "/viewStatusTCPO",
                      search: createSearchParams({
                        returnView: "viewClusterDashboard",
                      }).toString(),
                    })
                  }
                  className="h3 font-bold db-counters hyperlink-text-nocolor align-right"
                >
                  {noSlashedZero(optPercentage.toFixed(0)) + "%"}
                </div>
                <div>Optimized TCP</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledDiv>
  );
}
